import { BASE_URL } from '../../constants/defaultValues'
import Dictionary from '../dictionary'
import axios from 'axios'

const { bulkFilter } = Dictionary

const BulkFilterService = {
  download: async (payload:{}) => {
    return axios.post(BASE_URL + bulkFilter.bulkFilterDownload(),payload )
  },
}
export default BulkFilterService

